import { Injectable } from '@angular/core';
import { ApiService } from '../../../core/services/api/api.service';
import { LoginRequestBodyI } from './interfaces/login-request-body.interface';

@Injectable({
  providedIn: 'root',
})
export class LoginApiService {
  constructor(private readonly apiService: ApiService) {}

  login(loginRequestBody: LoginRequestBodyI) {
    return this.apiService.post<string>('auth/login', loginRequestBody);
  }
}
